import {HERO_ISOLATED_IMAGE, Hero, HeroBody, HeroCta, LINK_CTA, SIZE_SMALL} from '@mds/mds-reactjs-library'
import {useMemo} from 'react'
import {useIntl} from 'react-intl'

const Logout = () => {
  const intl = useIntl()

  const ctaData = useMemo(
    () => [{href: '/', label: intl.formatMessage({id: 'logout.login'}), alt: intl.formatMessage({id: 'product.name'})}],
    [intl]
  )

  return (
    <Hero
      eyebrow={intl.formatMessage({id: 'product.name'})}
      height="700px"
      title={intl.formatMessage({id: 'logout.title'})}
      titleSize={SIZE_SMALL}
      type={HERO_ISOLATED_IMAGE}
    >
      <HeroBody description={intl.formatMessage({id: 'logout.description'})} />
      <HeroCta data={ctaData} type={LINK_CTA} />
    </Hero>
  )
}

export default Logout
